import {Button,Form, Input } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import apiCalls from "src/api/apiCalls";
import Loader from "../shared/loader.component";
import { alphanumericPattern, passwordValidation } from "src/utils/custom.validator";
import AppCheckbox from "../shared/appCheckBox";
import ErrorMessage from "../shared/messages/errorMessage";
import PhoneCodeDropdown from "../shared/phCodeDropdown";
import { isErrorMessage } from "../shared/error.message";
import { PasswordInstructions } from "./service";
import SelectInput from "../shared/selectInput";

const AddUserForm = () => {
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [btnLoader,setBtnLoader]=useState(false)
    const [loader,setLoader]=useState(false)
    const [rolesListData,setRolesListData]=useState([])
    const [isActiveCheck,setIsActiveCheck]=useState(true)
    const [lockedOutCheck,setLockedOutCheck]=useState(true)
    const [selectPhoneCode,setSelectPhoneCode]=useState([])
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { mode,id } = useParams();

     useEffect(()=>{
        if(mode === 'edit'){
            getUserDetails();
        }
        rolesData();
     },[])

     const parsePhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return { phoneCode: null, number: "" };
        
        const parts = phoneNumber.split(" ");
        if (parts.length <= 1) return { phoneCode: null, number: phoneNumber };
        
        return {
            phoneCode: parts[0],
            number: parts.slice(1).join(" ")
        };
    };

    const getUserDetails = useCallback(async () => {
        try {
            setErrorMessage();
            setLoader(true);
            const res = await apiCalls.getUserData(id);
            
            if (!res.ok) {
                setLoader(false);
                apiCalls.isErrorDispaly(res?.data?.error?.message);
                window.scroll(0, 0);
                return;
            }

            setLoader(false);
            setIsActiveCheck(res?.data?.isActive);
            setLockedOutCheck(res?.data?.lockoutEnabled);
            setSelectedRoles(Array.isArray(res?.data?.roleNames) ? res?.data?.roleNames : []);
            
            const { phoneNumber, ...restData } = res?.data;
            const { phoneCode, number } = parsePhoneNumber(phoneNumber);
            
            form.setFieldsValue({
                ...restData,
                phoneNumber: number,
            });
            setSelectPhoneCode(phoneCode);
            
        } catch (error) {
            setLoader(false);
            apiCalls.isErrorDispaly(error?.message);
            window.scroll(0, 0);
        }
    }, []);

    const rolesData = async () => {
        try {
            setErrorMessage(null)
            setLoader(true)
            const responce = await apiCalls.rolesListData()
            if (responce?.ok) {
                setErrorMessage(null)
                setLoader(false)
                setRolesListData(responce?.data?.items)
            }
            else {
                setLoader(false)
                apiCalls.isErrorDispaly(responce?.data?.error?.message)
                window.scroll(0,0)
            }
        } catch (error) {
            setLoader(false)
            apiCalls.isErrorDispaly(error?.message)
            window.scroll(0,0)
        }
    }

    const formatPhoneNumber = useCallback((phoneCode, phoneNum) => {
        if (phoneCode && typeof phoneCode === 'object') {
            phoneCode = phoneCode.value || '';
        }
        
        if (phoneNum?.startsWith(phoneCode)) {
            return phoneNum;
        } else if (phoneCode && phoneNum) {
            return `${phoneCode} ${phoneNum}`;
        }
        return "";
    }, []);

    const createUserObject = useCallback((values, phoneNumber) => {
        return {
            "userName": values?.userName,
            "password": values?.password,
            "name": values?.name,
            "surname": values?.surname,
            "email": values?.email,
            "phoneNumber": phoneNumber,
            "roleNames": selectedRoles,
            "isActive": isActiveCheck,
            "lockoutEnabled": lockedOutCheck,
            "shouldChangePasswordOnNextLogin": false,
            "organizationUnitIds": []
        };
    }, [selectedRoles, isActiveCheck, lockedOutCheck]);

    const createEditObject = useCallback((values, phoneNumber) => {
        return {
            "userName": values?.userName,
            "name": values?.name,
            "surname": values?.surname,
            "email": values?.email,
            "phoneNumber": phoneNumber,
            "roleNames": selectedRoles,
            "isActive": isActiveCheck,
            "lockoutEnabled": lockedOutCheck,
        };
    }, [selectedRoles, isActiveCheck, lockedOutCheck]);

    const handleApiResponse = useCallback(async (apiCall, payload) => {
        const response = await apiCall(payload);
        if (response.ok) {
            setBtnLoader(false);
            navigate('/settings/users');
        } else {
            setBtnLoader(false);
            setErrorMessage(isErrorMessage(response?.data));
            window.scroll(0, 0);
        }
    }, [navigate]);

    const onSubmit = useCallback(async() => {
        try {
            const formData = await form.validateFields();
            const values = Object?.fromEntries(Object?.entries(formData)?.map(([key, val]) => [key, typeof val === 'string' ? val?.trim() : val]));
            
            let phoneCode = '';
            if (selectPhoneCode) {
                phoneCode = typeof selectPhoneCode === 'object' ? 
                    (selectPhoneCode.value || '') : 
                    selectPhoneCode;
            }
            
            const phoneNum = values?.phoneNumber || "";
            const phoneNumber = formatPhoneNumber(phoneCode, phoneNum);

            setErrorMessage(null);
            setBtnLoader(true);

            if(mode === 'add') {
                const addObj = createUserObject(values, phoneNumber);
                await handleApiResponse(apiCalls.saveUserDatials, addObj);
            } else {
                const editObj = createEditObject(values, phoneNumber);
                await handleApiResponse((payload) => apiCalls.editUserDatials(id, payload), editObj);
            }
        } catch (error) {
            setBtnLoader(false);
            setErrorMessage(error?.message);
            window.scroll(0, 0);
        }
    }, [form, mode, id, navigate, selectPhoneCode, formatPhoneNumber, createUserObject, createEditObject, handleApiResponse]);

    const cancelButtonHandler = useCallback(() => {
        navigate('/settings/users');
    },[navigate])

    const handleRoleChange = useCallback((e) => {
        setSelectedRoles([e]);
    },[])
    
    const closeErrorHandler=useCallback(()=>{
          setErrorMessage(null)
       },[])

    const isActiveCheckBoxHandler=useCallback((e)=>{
            setIsActiveCheck(e)
    },[])
    const lockedOutCheckBoxHandler=useCallback((e)=>{
            setLockedOutCheck(e)
    },[])

    const setField=useCallback((field)=>(e)=>{
        let value = e ||null
        setSelectPhoneCode({...[field],value})
    },[])

    return (
         <div className=''>
            {errorMessage && <ErrorMessage msg={errorMessage} onClose={closeErrorHandler} />}
            {loader ? <div className="h-[80vh] flex justify-center items-center"><Loader className="" /></div>:
              (<Form
                form={form}
                layout="vertical"
                initialValues={{
                    isActive: isActiveCheck,
                    lockedOut: lockedOutCheck
                }}
                onFinish={onSubmit}
                validateTrigger="onSubmit"
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center',
                  }}
            >
                <div className="addcards-form rounded-5">
                    <div className="grid md:grid-cols-2 gap-4">
                        <div>
                            <Form.Item className="custom-input mb-0" name="userName" label="User Name" rules={[
                                { required: true, message: "Is required",validateTrigger: "onBlur" },
                                { pattern:alphanumericPattern, 
                                message: "Invalid username.",validateTrigger: "onBlur" }
                            ]}>
                                <Input placeholder="Enter User Name" className="w-full appearance-none " maxLength={50}/>
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item className="custom-input mb-0" name="name" label="First Name" rules={[
                                { required: true, message:"Is required",validateTrigger: "onBlur" },
                                { pattern:alphanumericPattern, message: "Invalid firstname.",validateTrigger: "onBlur" }
                            ]}>
                                <Input placeholder="Enter First Name"  className="w-full appearance-none "  maxLength={50}/>
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item className="custom-input mb-0" name="surname" label="Last Name" rules={[
                                { required: true, message: "Is required",validateTrigger: "onBlur" },
                                { pattern:alphanumericPattern, message: "Invalid lastname.",validateTrigger: "onBlur" }
                            ]}>
                                <Input placeholder="Enter Last Name"  className="w-full appearance-none "  maxLength={50}/>
                            </Form.Item>
                        </div>
                            {mode === 'add' && (
                                <div className="!relative">
                                    <PasswordInstructions/>
                                   <Form.Item
                                        className="custom-input mb-0 password-input relative"
                                        name="password"
                                        rules={[
                                            { required: true, message: "Is required" },
                                            { validator: passwordValidation }
                                        ]}
                                        label="Password"
                                    >
                                        <Input.Password
                                            placeholder="Enter Password"
                                            className="w-full appearance-none custom-password !pr-9"
                                            maxLength={50}
                                        />
                                    </Form.Item>
                               </div>
                            )}
                        <div>
                            <Form.Item className="custom-input mb-0" name="phoneNumber" label="Phone Number"
                             rules={[
                                { pattern:  /^\d{6,12}$/, message: "Invalid mobile number.",validateTrigger: "onBlur" }
                              ]}
                            >
                                <Input
                                    addonBefore={<PhoneCodeDropdown onChange={setField("phoneCode")} value={selectPhoneCode}/>} 
                                placeholder="Phone Number"
                                maxLength={12}
                                />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item className="custom-input mb-0" name="email" label="Email" 
                            rules={[
                                { required: true, message: "Is required" },
                                { 
                                    type: "email", 
                                    message: "Invalid Email", 
                                    validateTrigger: "onBlur"
                                },
                                ]}>
                                <Input placeholder="Enter Email"  maxLength={50}/>
                            </Form.Item>
                        </div>
                        
                    </div>
                    <div className="grid md:grid-cols-2 gap-4 mt-3">
                        <div className="">
                            <h2 className="text-subTextColor text-lg font-medium">Role</h2>
                            <Form.Item  className="mb-0">
                                <SelectInput
                                    options={rolesListData}
                                    onChange={handleRoleChange}
                                    value={selectedRoles}
                                    multiple={false}
                                    optionValue="name"
                                    optionLabel="name"
                                    fieldName="Role"
                                    allowClear={false}
                                />
                            </Form.Item>
                            </div>
                        <div className="self-center">
                            <Form.Item name="isActive" className="mb-0">
                                <AppCheckbox
                                    checked={isActiveCheck}
                                    onChange={isActiveCheckBoxHandler}
                                    onChangeParams={"checked"}
                                    className="cursor-pointer text-whiteText"
                                />
                                <span className="text-whiteText ms-2">Is Active</span>
                            </Form.Item>
                        </div>
                        <div className="self-center">
                            <Form.Item name="lockedOut" className="mb-0">
                                <AppCheckbox
                                    checked={lockedOutCheck}
                                    onChange={lockedOutCheckBoxHandler}
                                     onChangeParams={"checked"}
                                    className="cursor-pointer text-whiteText"
                                />
                                <span className="text-whiteText ms-2">Locked Out</span>
                            </Form.Item>
                        </div>
                        </div>
                </div>
                <div className="mt-7 md:flex justify-end gap-2 space-y-2 md:space-y-0">
                    <Button
                        type="default"
                        className="cancel-btn !p-5"
                        onClick={cancelButtonHandler}
                    >
                        Cancel
                    </Button>
                    <Button type="primary" className="primary-btn" htmlType="submit" loading={btnLoader}>
                        Save
                    </Button>
                </div>
            </Form>)}
        </div>
    );
};

export default AddUserForm;
